/**
 * Linha roxa/ciano "Ofertas exclusivas por tempo limitado" — usada no banner
 * da home, na LP do catálogo e nos pop-ups da ação. Sempre em 1 linha
 * (whitespace-nowrap) com fonte que acompanha a largura da tela, inclusive
 * no celular.
 */
export const BLACKFEO_TAGLINE = "Ofertas exclusivas por tempo limitado";
export const BLACKFEO_TAGLINE_CLS =
  "whitespace-nowrap font-extrabold uppercase tracking-wider text-black-campaign-cyan text-[clamp(0.6rem,3vw,0.875rem)]";
